import { Observable } from "rxjs/internal/Observable";
import { OpenBarrierRequest } from "./models/open-barrier-request";

export abstract class OpenBarrierBase {
    abstract postOpenBarrier(device_id: number): Observable<OpenBarrierRequest>;
}